<template>
  <div class="home page">
    <div class="new-slider">
      <div class="slides">
        <transition
          name="imageAnim"
          @before-enter="imgbeforeEnter"
          @enter="imgenter"
          @leave="imgleave"
        >
          <div
            class="image-box"
            :class="getview"
            :key="getview"
            keep-alive
          ></div>
        </transition>
        <transition
          name="sanim"
          @before-enter="beforeEnter"
          @enter="enter"
          @leave="leave"
        >
          <div v-if="getview === 'slide1'" class="slide slide1" key="'slide1'">
            <div class="box">
              <div class="slide-title">Creative Code</div>
              <div class="slide-sub">
                Front End Development & Design
                <anim-arrow link="/about">
                  <slot name="link"><span>Find out more </span></slot>
                </anim-arrow>
              </div>
            </div>
          </div>
          <div v-if="getview === 'slide2'" class="slide slide2" key="'slide2'">
            <div class="box">
              <div class="slide-title">Drupal</div>
              <div class="slide-sub">
                5 years of theming drupal 7 and 8

                <anim-arrow link="/drupal">
                  <slot name="link"><span>Find out more </span></slot>
                </anim-arrow>
              </div>
            </div>
          </div>
          <div v-if="getview === 'slide3'" class="slide slide3" key="'slide3'">
            <div class="box">
              <div class="slide-title">Wordpress</div>
              <div class="slide-sub">
                designing and creating custom themes
                <anim-arrow link="/wordpress">
                  <slot name="link"><span>Find out more </span></slot>
                </anim-arrow>
              </div>
            </div>
          </div>
          <div v-if="getview === 'slide4'" class="slide slide4" key="'slide4'">
            <div class="box">
              <div class="slide-title">Vue / Nuxt</div>
              <div class="slide-sub">
                Jamstack and SSR
                <anim-arrow link="/js">
                  <slot name="link"><span>Find out more </span></slot>
                </anim-arrow>
              </div>
            </div>
          </div>
          <div v-if="getview === 'slide5'" class="slide slide5" key="'slide5'">
            <div class="box">
              <div class="slide-title">Animation</div>
              <div class="slide-sub">
                Interaction & Visualization

                <anim-arrow link="/animation">
                  <slot name="link"><span>Find out more </span></slot>
                </anim-arrow>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="slider-nav">
        <div class="slider-nav-item prev" @click="prev">
          <arrow-thingy :rotation="-90" />
        </div>
        <div class="slider-nav-item next" @click="next">
          <arrow-thingy :rotation="90" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import arrowThingy from "@/components/ArrowThingy";
import animArrow from "../components/AnimArrow.vue";
export default {
  name: "home",
  components: {
    arrowThingy,
    animArrow,
  },
  data() {
    return {
      activeView: 0,
      views: ["slide1", "slide2", "slide3", "slide4", "slide5"],
      slideHeight: 0,
      slideWidth: 0,
      slideBack: false,
    };
  },
  mounted() {
    this.getDims();
    window.addEventListener("resize", this.getDims);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getDims);
  },

  methods: {
    getDims() {
      this.slideHeight = this.$el.offsetHeight;
      this.slideWidth = this.$el.offsetWidth;
    },
    // nav
    next() {
      if (this.activeView !== this.views.length - 1) {
        this.activeView++;
      } else {
        this.activeView = 0;
      }
      this.slideBack = false;
    },
    prev() {
      if (this.activeView !== 0) {
        this.activeView--;
      } else {
        this.activeView = this.views.length - 1;
      }
      this.slideBack = true;
    },

    //anim image bg
    imgbeforeEnter(el) {
      gsap.set(el, { alpha: 0 });
    },

    imgenter(el, done) {
      let tl = gsap.timeline({
        onComplete: done,
      });

      let opa =
        el.className.includes("slide5") && this.slideWidth <= 768 ? 0.7 : 1;
      tl.to(el, { duration: 2, ease: "easeOut", alpha: opa });
      tl.play();
    },

    imgleave(el, done) {
      let tl = gsap.timeline({
        onComplete: done,
      });

      //tl.to( el, { duration: 2, y:'200vh',  ease: 'easeOut', alpha: 0});
      tl.to(el, { duration: 2, ease: "easeOut", alpha: 0 });

      tl.play();
    },

    // anim titles
    beforeEnter(el) {
      let slideTitle = el.querySelector(".slide-title");

      let slideSub = el.querySelector(".slide-sub");
      gsap.set(slideTitle, { letterSpacing: "1000px", color: "black" });

      if (this.slideBack) {
        gsap.set(slideSub, { y: -this.slideHeight });
      } else {
        gsap.set(slideSub, { y: this.slideHeight });
      }
    },
    enter(el, done) {
      let tl = gsap.timeline({
        onComplete: done,
      });
      let slideTitle = el.querySelector(".slide-title");
      let slideSub = el.querySelector(".slide-sub");
      tl.to(slideTitle, {
        duration: 1.5,
        letterSpacing: "1px",
        ease: "easeOut",
        color: "#d666af",
      });
      tl.to(slideSub, { duration: 1.5, y: 0, ease: "easeOut" }, "<");
      tl.play();
    },

    leave(el, done) {
      let tl = gsap.timeline({
        onComplete: done,
      });
      let leavePosY = this.slideBack ? this.slideHeight : -this.slideHeight;
      let slideTitle = el.querySelector(".slide-title");
      let slideSub = el.querySelector(".slide-sub");
      tl.to(slideTitle, {
        duration: 1.5,
        letterSpacing: "500px",
        color: "black",
        ease: "easeOut",
      });
      tl.to(slideSub, { duration: 1.5, y: leavePosY, ease: "easeOut" }, "<");

      tl.play();
    },
  },
  computed: {
    getview() {
      return this.views[this.activeView];
    },
  },
};
</script>

<style lang="scss">
@import "../scss/_typography.scss";

.new-slider {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(90deg, #a093d6, #e4b9dd);
  position: relative;
  @include breakpoint(lg) {
    background: linear-gradient(
      90deg,
      #0f0f2f,
      #000052 50%,
      #e2dbff 50%,
      #de93d1
    );
  }
  .box {
    overflow: hidden;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    mix-blend-mode: color-dodge;
    a {
      color: #e4e4e4;
    }
  }
}
.slide,
.slides {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  display: block;
}

.slide {
  display: flex;
  align-items: center;
}

.image-box {
  width: 100%;
  height: 100%;
  right: 0;
  top: 0;

  position: absolute;
  display: block;
  background-position: 50% 100%;
  will-change: opacity;
  @include breakpoint(lg) {
    width: 50.1%;
  }

  // web dev
  &.slide1 {
    background-image: url("../assets/img/iPad_1.jpg");

    background-size: cover;
    background-position: center center;
    mix-blend-mode: color-burn;

    @include breakpoint(lg) {
      background-image: url("../assets/img/drew-beamer-3SIXZisims4-unsplash.png");
      mix-blend-mode: overlay;
    }
    &::before {
      content: " ";
      height: 100%;
      width: 100%;
      display: block;
      position: absolute;
      visibility: hidden;
      background-image: url("../assets/img/drew-beamer-3SIXZisims4-unsplash.png"),
        url("../assets/img/d8.png"), url("../assets/img/hero-img-3.jpg"),
        url("../assets/img/hero-img-4.jpg"),
        url("../assets/img/jeremy-perkins-vcy_SuLbM7A-unsplash.png");
    }
  }

  //drupal
  &.slide2 {
    background-image: url("../assets/img/d8.png");

    background-repeat: repeat;
    background-position: center center;
    background-size: 100px;
    mix-blend-mode: multiply;
  }
  //wp
  &.slide3 {
    background-image: url("../assets/img/hero-img-3.jpg");
    background-size: cover;
    background-position: center center;
  }

  //vue nuxt
  &.slide4 {
    background-image: url("../assets/img/hero-img-4.jpg");
    background-size: cover;
    background-position: center center;
    mix-blend-mode: multiply;
  }
  //animation
  &.slide5 {
    background-image: url("../assets/img/jeremy-perkins-vcy_SuLbM7A-unsplash.png");
    background-size: cover;
    background-position: center center;
    mix-blend-mode: multiply;
    @include breakpoint(lg) {
      mix-blend-mode: hard-light;
    }
  }
}

.slide-title {
  font-size: 7.5vw;
  font-weight: 800;
  line-height: 1;
  display: inline-block;
  white-space: nowrap;
  padding-left: 100px;
  color: #d666af;
}
.slide-sub {
  padding-left: 100px;
  padding-top: 1rem;
  color: #ececec;
  font-size: 1.25rem;
  line-height: 1.5;
  display: block;
}
.slider-nav {
  position: absolute;

  left: 0;
  top: 0;
  height: 100%;
  width: 80px;

  display: flex;
  flex-direction: column;
  justify-content: center;
}
.slider-nav-item {
  height: 80px;
  & > div {
    height: 100%;
  }
}
</style>
